export default __webpack_public_path__ + "static/media/sweetmoment.b92a12ea.jpeg";